import React from 'react';

// Карандаш + подпись «Редактировать» (замена иконки izmenit.svg с надписью «Изменить»)
const EditButton = ({ onClick, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Редактировать"
    className={`flex-shrink-0 flex items-center gap-[6px] cursor-pointer w-full ${className}`}
  >
    <img src="/icons/fa-solid_edit.svg" alt="Редактировать" className="w-[16px] h-[16px]" />
    <span className="font-raleway text-[16px] leading-none text-[#A1F69E]">Редактировать</span>
  </button>
);

export default EditButton;
